// extracted by mini-css-extract-plugin
export var analyticsSecondary = "index-module--analyticsSecondary--spOWM";
export var bookkeepingSecondary = "index-module--bookkeepingSecondary--KIPIL";
export var employeeSecondary = "index-module--employeeSecondary--E1pfj";
export var featureWrapper = "index-module--feature-wrapper--kt-I8";
export var listingSecondary = "index-module--listingSecondary--GyMRg";
export var mergeSecondary = "index-module--mergeSecondary--j7xLz";
export var sectionWrapper = "index-module--section-wrapper--9JyVw";
export var updateSoldSecondary = "index-module--updateSoldSecondary--wGVAn";